import type { FetcherArgs } from '@ricoh/ria.client.core/plugins/swr/fetcher';
import type { Middleware, SWRHook } from 'swr';

import { ClientError, ServiceError } from '@ricoh/ria.client.core/errors';

import authenticator from './_plugin';

const authMiddleware: Middleware =
  (useSWRNext: SWRHook): ReturnType<Middleware> =>
  (key, fetch, options) => {
    if (!fetch) {
      return useSWRNext(key, fetch, options);
    }

    const authFetcher = async (...args: FetcherArgs) => {
      try {
        return await fetch(...args);
      } catch (exception) {
        const error = ClientError.create({
          module: 'plugin',
          message: 'Execute fetching handler failed',
          cause: exception,
        });

        if (error instanceof ServiceError && error.status === 401) {
          authenticator.redirectSignin(globalThis.location.href);
        }

        throw error;
      }
    };

    return useSWRNext(key, authFetcher, options);
  };

export default authMiddleware;
